import { ColumnDef } from '@tanstack/react-table';
import { Product } from 'src/trpc';
import { Button } from '@/components/ui/button';
import { Edit } from 'lucide-react';
import { MoneyFromCents } from '@libs/services/money';

export const productColumns: ColumnDef<Product>[] = [
  {
    accessorKey: 'label',
    header: 'Name',
    cell: ({ row }) => {
      const isArchived = row.getValue('archived');
      return (
        <div className={`font-medium ${isArchived ? 'line-through text-muted' : ''}`}>
          {row.getValue('label')}
        </div>
      );
    },
  },
  {
    accessorKey: 'description',
    header: 'Description',
    cell: ({ row }) => (
      <div className="max-w-xs truncate">{row.getValue('description') || '-'}</div>
    ),
  },
  {
    accessorKey: 'priceInCents',
    header: 'Price',
    cell: ({ row }) => (
      <div>{MoneyFromCents(Number(row.getValue('priceInCents')) || 0).toFormat()}</div>
    ),
  },
  {
    accessorKey: 'collectTaxes',
    header: 'Collect Taxes',
    cell: ({ row }) => (
      <div className="flex flex-row items-center gap-2">
        <div
          className={`px-4 py-1 rounded-full text-xs font-medium ${
            row.getValue('collectTaxes')
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-800'
          }`}
        >
          {row.getValue('collectTaxes') ? 'Yes' : 'No'}
        </div>
      </div>
    ),
  },
  {
    accessorKey: 'customerVisible',
    header: 'Customer Visible',
    cell: ({ row }) => (
      <div className="flex flex-row items-center gap-2">
        <div
          className={`px-4 py-1 rounded-full text-xs font-medium ${
            row.getValue('customerVisible')
              ? 'bg-green-100 text-green-800'
              : 'bg-gray-100 text-gray-800'
          }`}
        >
          {row.getValue('customerVisible') ? 'Yes' : 'No'}
        </div>
      </div>
    ),
  },
  {
    accessorKey: 'archived',
    header: 'Status',
    cell: ({ row }) => {
      const isArchived = row.getValue('archived');
      return (
        <div className="flex flex-row items-center gap-2">
          <div
            className={`px-4 py-1 rounded-full text-xs font-medium ${
              isArchived ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
            }`}
          >
            {isArchived ? 'Archived' : 'Active'}
          </div>
        </div>
      );
    },
  },
  {
    id: 'actions',
    header: 'Actions',
    cell: ({ row }) => {
      const product = row.original as Product & { onEdit: (product: Product) => void };
      return (
        <Button
          variant="ghost"
          size="sm"
          onClick={() => product.onEdit(product)}
          className="h-8 w-8 p-0"
        >
          <Edit className="h-4 w-4" />
        </Button>
      );
    },
  },
];
